import React from 'react';
import moment from 'moment';
import Button from '../../components/Button/Button';
import {
  FaArrowLeft,
  FaClipboardList,
  FaBook,
  FaClipboardCheck,
  FaChalkboardTeacher,
  FaLayerGroup,
  FaStar,
  FaCalendarAlt,
  FaAlignLeft,
} from 'react-icons/fa';
import { getTermLabel } from "../../utils/helper";
import './AssessmentInfo.css';

const InfoTile = ({ icon, label, value }) => (
  <div className="assessment-detail-tile">
    <div className="assessment-detail-tile-icon">{icon}</div>
    <div>
      <div className="assessment-detail-tile-label">{label}</div>
      <div className="assessment-detail-tile-value">{value || 'NA'}</div>
    </div>
  </div>
);

const AssessmentInfo = ({ eventInfo, back }) => {
  return (
    <div className="animated">
      <div className="card">
        <div className="assessment-detail-header">
          <div className="assessment-detail-heading">
            <div className="assessment-detail-icon">
              <FaClipboardList />
            </div>
            <div>
              <div className="assessment-detail-eyebrow">Assessment Details</div>
              <div className="assessment-detail-name">
                {eventInfo?.name?.name || '—'}
              </div>
              {eventInfo?.term && (
                <span className="assessment-detail-term">{getTermLabel(eventInfo.term)}</span>
              )}
            </div>
          </div>
          <Button variant="secondary" onClick={back} icon={<FaArrowLeft />}>
            Back
          </Button>
        </div>

        <div className="assessment-detail-body">
          <div className="assessment-detail-grid">
            <InfoTile icon={<FaBook />} label="Subject" value={eventInfo?.subject?.name} />
            <InfoTile icon={<FaClipboardCheck />} label="Evaluation" value={eventInfo?.evaluation_type?.name} />
            <InfoTile icon={<FaChalkboardTeacher />} label="Class" value={eventInfo?.program?.name} />
            <InfoTile icon={<FaLayerGroup />} label="Grade Scheme" value={eventInfo?.grade_scheme?.name} />
            <InfoTile icon={<FaStar />} label="Max Score" value={eventInfo?.max_score} />
            <InfoTile
              icon={<FaCalendarAlt />}
              label="Start"
              value={eventInfo?.start && moment(eventInfo.start).format("DD-MMM-YYYY")}
            />
            <InfoTile
              icon={<FaCalendarAlt />}
              label="End"
              value={eventInfo?.end && moment(eventInfo.end).format("DD-MMM-YYYY")}
            />
          </div>

          {eventInfo?.description && (
            <div className="assessment-detail-description">
              <div className="assessment-detail-description-label">
                <FaAlignLeft /> Description
              </div>
              <div className="assessment-detail-description-value">{eventInfo.description}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentInfo;
